import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { MatchEvent, MatchEventType } from "../directus/collections";
import { EVENTS_LABELS } from "../shared";

export function MatchEventsTable({ events }: { events: MatchEvent[] }) {
  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>Timestamp</TableCell>
              <TableCell>Tipo Evento</TableCell>
              <TableCell>Target ID</TableCell>
              <TableCell>Valore</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event, index) => (
              <TableRow key={index}>
                <TableCell>
                  {new Date(event.date_created).toLocaleString()}
                </TableCell>
                <TableCell>
                  {EVENTS_LABELS[event.type as MatchEventType] || event.type}
                </TableCell>
                <TableCell>{event.target_id}</TableCell>
                <TableCell>{event.value || "N/A"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
